import React, { ChangeEvent, useEffect } from "react";
import IPurchaseOrderOrderItemDetailUI from "../../../models/IPurchaseOrderOrderItemDetailUI";
import IPurchaseOrderOrderItemDetail from "../../../models/IPurchaseOrderOrderItemDetail";
import IVendor_Source from "../../../models/IVendor_Source";
import ICatalog_Item_Vendor_Source_Map from "../../../models/ICatalog_Item_Vendor_Source_Map";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import UIService from "../../../services/UIService";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";

type Props = {
    data: IOrder_ItemUI;
    purchaseOrderRows: IPurchaseOrderOrderItemDetail[];
    checkRowForPurchaseOrder: (orderItemGuid: string, isChecked: boolean, qty: number, vendorSource?: number) => void;
    vendorSourcesForCatalogItems?: { [key: string]: IVendor_Source[] };
};

export const OrderActionColVendorSource = (props: Props) => {
    const [purchaseOrderRow, setPurchaseOrderRow] = React.useState<IPurchaseOrderOrderItemDetailUI>({
        isChecked: false,
        orderItemGuid: "",
        minQty: 0,
        qty: 0,
        hasVendorSource: false,
    } as IPurchaseOrderOrderItemDetailUI);
    const [rowIsChecked, setRowIsChecked] = React.useState(false);
    const [purchaseOrderQty, setPurchaseOrderQty] = React.useState(0);
    const [availableVendorSourcesForCatalogItem, setAvailableVendorSourcesForCatalogItem] = React.useState<IVendor_Source[]>();
    const [selectedVendorSource, setSelectedVendorSource] = React.useState<IVendor_Source | undefined>();
    const [selectedVendorSourceMap, setSelectedVendorSourceMap] = React.useState<ICatalog_Item_Vendor_Source_Map | undefined>();

    const updatePurchaseOrderRow = () => {
        if (props.purchaseOrderRows) {
            for (const row of props.purchaseOrderRows) {
                if (row.orderItemGuid === props.data.guid) {
                    const _row = row as IPurchaseOrderOrderItemDetailUI;
                    _row.hasVendorSource = true;
                    setPurchaseOrderRow(_row as IPurchaseOrderOrderItemDetailUI);
                }
            }
        }
    };

    const updateVendorSources = () => {
        if (props.vendorSourcesForCatalogItems) {
            if (props.vendorSourcesForCatalogItems) {
                for (const catalogItemGuid of Object.keys(props.vendorSourcesForCatalogItems)) {
                    const vendorSourceDetail = props.vendorSourcesForCatalogItems[catalogItemGuid];

                    if (catalogItemGuid === props.data.Catalog_Item!.guid) {
                        setAvailableVendorSourcesForCatalogItem(vendorSourceDetail);
                    }
                }
            }
        }
    };

    useEffect(() => {
        updatePurchaseOrderRow();
        updateVendorSources();
    }, []);

    useEffect(() => {
        updatePurchaseOrderRow();
    }, [props.purchaseOrderRows]);

    useEffect(() => {
        updateVendorSources();
    }, [props.vendorSourcesForCatalogItems]);

    useEffect(() => {
        props.checkRowForPurchaseOrder(props.data.guid, purchaseOrderRow.isChecked, purchaseOrderRow.qty, selectedVendorSource?.id);
    }, [purchaseOrderRow]);

    const checkRowForPurchaseOrder = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const _purchaseOrderRow = {
            ...purchaseOrderRow,
        };

        _purchaseOrderRow.isChecked = value;

        setPurchaseOrderRow(_purchaseOrderRow);
        setRowIsChecked(value);
    };

    const handlePurchaseOrderQtyChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const _purchaseOrderRow = {
            ...purchaseOrderRow,
        };

        if (Number(value) >= 0) {
            _purchaseOrderRow.qty = value;
        }

        if (_purchaseOrderRow.minQty) {
            if (Number(_purchaseOrderRow.qty) < _purchaseOrderRow.minQty) {
                _purchaseOrderRow.qty = Number(_purchaseOrderRow.minQty);
            }
        }

        setPurchaseOrderRow(_purchaseOrderRow);
        setPurchaseOrderQty(value);
    };

    const selectVendorSource = (e: ChangeEvent<any>) => {
        if (e && e.target) {
            const value = e.target.value;
            const name = e.target.name;

            console.log(`Select Vendor Source: ${value}, ${props.data.Catalog_Item!.guid}`);

            if (availableVendorSourcesForCatalogItem) {
                for (const vendorSource of availableVendorSourcesForCatalogItem) {
                    if (vendorSource.id === Number(value)) {
                        const _purchaseOrderRow = {
                            ...purchaseOrderRow,
                        };

                        if (vendorSource.Catalog_Item_Vendor_Source_Map) {
                            _purchaseOrderRow.minQty = vendorSource.Catalog_Item_Vendor_Source_Map.min_order_qty || 0;
                        }

                        setSelectedVendorSource(vendorSource);
                        setSelectedVendorSourceMap(vendorSource.Catalog_Item_Vendor_Source_Map);
                        setPurchaseOrderRow(_purchaseOrderRow);
                    }
                }
            }
        }
    };

    return (
        <div className={"OrderActionColVendorSource"}>
            <div className={"d-flex align-items-center"}>
                <OwCheckbox
                    name={"orderItemGuid"}
                    fn={checkRowForPurchaseOrder}
                    truthyVal={true}
                    falsyVal={false}
                    checked={purchaseOrderRow.isChecked}
                    disabled={!purchaseOrderRow.hasVendorSource}
                />
                {!purchaseOrderRow.isChecked ? null : (
                    <div className={"mt-3 ms-2 min-w-10r d-flex flex-column align-items-start"}>
                        <div>
                            <OwLabel className={"no-wrap"} title={"vendor_source"} />
                        </div>
                        <div className={"d-flex align-items-center mb-1"}>
                            <OwSelectOption
                                fn={selectVendorSource}
                                titleProp={"name"}
                                valueProp={"id"}
                                name={"vendor_source"}
                                options={availableVendorSourcesForCatalogItem}
                                isRequired={true}
                                selectedOption={props.data.Catalog_Item}
                                selectedOptionProp={"default_vendor_source_id"}
                                autoSelectSingleOption={true}
                                emitOnLoad={true}
                                emitTarget={true}
                            />
                        </div>
                        <div>
                            <OwLabel title={"qty"} noBottomMargin={true} className={"me-2"} />
                        </div>
                        <div className={"d-flex align-items-center"}>
                            <OwInputWrapper
                                name={"purchaseOrderQty"}
                                type={"number"}
                                value={purchaseOrderRow.qty}
                                fn={handlePurchaseOrderQtyChange}
                                onWheelFn={UIService.stopScrollWheel}
                            />
                        </div>
                        <div className={"text-small"}>
                            <OwLabel title={"min_qty"} postText={":"} className={"me-2"} />
                            {purchaseOrderRow.minQty}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
